import { render, staticRenderFns } from "./CampaignSubmit.vue?vue&type=template&id=da6b8b2e&scoped=true"
import script from "./CampaignSubmit.vue?vue&type=script&lang=ts"
export * from "./CampaignSubmit.vue?vue&type=script&lang=ts"
import style0 from "./CampaignSubmit.vue?vue&type=style&index=0&id=da6b8b2e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6b8b2e",
  null
  
)

export default component.exports